export default "Patrimoine public — Rénovation énergétique mairies, écoles, gymnases | Solution Éco France";
